import { useCallback, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import debounce from 'lodash/debounce';

export enum AutoSaveState {
	Submitting,
	Saved,
}

interface IAutoSaveProps {
	debounceMs: number;
	onAutoSaveStateChange?: (saveState: AutoSaveState) => void;
}

const AutoSave = ({ debounceMs, onAutoSaveStateChange = () => {} }: IAutoSaveProps) => {
	const [initialized, setInitialized] = useState<boolean>(false);
	const formik = useFormikContext();
	const debouncedSubmit = useCallback(
		debounce(() => {
			return formik.submitForm();
		}, debounceMs),
		[formik.submitForm, debounceMs],
	);

	useEffect(() => {
		if (initialized) {
			debouncedSubmit();
		} else {
			setInitialized(true);
		}
	}, [debouncedSubmit, formik.values]);

	useEffect(() => {
		onAutoSaveStateChange(formik.isSubmitting ? AutoSaveState.Submitting : AutoSaveState.Saved);
	}, [formik.isSubmitting]);

	return null;
};

export default AutoSave;
